import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit {

  @Input() total : number = 0;
  @Input() limit : number = 0;
  @Input() base  = '';
  
  protected numberPages : number = 0;
  protected render = "";

  constructor() { }

  ngOnInit() {
    this.numberPages = this.calculNumberPages();

    this.generateRender();
  }

  calculNumberPages() {
    return Math.ceil(this.total / this.limit);
  }

  generateRender() {
    for(var i=1; i <= this.numberPages; i++) {
      this.render += '<li><a href="'+this.base+'/'+i+'">'+i+'</a></li>';
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pagination/pagination.component.ts